<template>
  <span v-if="list">
    <template v-for="(listItem, index) in item">
      <span :key="index">{{ getListItemFormated(listItem, index) }}</span>
      <br :key="`${index}-br`" v-if="listBreak" />
    </template>
  </span>
  <span v-else>{{ classifierText }}</span>
</template>

<script>
export default {
  name: 'ElTableClassifier',
  props: {
    classifier: Object,
    item: [String, Array],
    list: Boolean,
    listBreak: Boolean,
  },
  computed: {
    classifierText() {
      if (this.classifier && this.item) {
        return this.$i18n.locale === 'lt'
          ? this.getClassifierTitle(this.classifier.lt).text
          : this.getClassifierTitle(this.classifier.en).text
      } else {
        return ''
      }
    },
  },
  methods: {
    getListItemFormated(item, index) {
      let text = this.getListItem(item)
      if (index < this.item?.length - 1) {
        text += ', '
      }
      return text
    },
    getListItem(item) {
      if (this.classifier && item) {
        return this.$i18n.locale === 'lt'
          ? this.getClassifierListTitle(item, this.classifier.lt).text
          : this.getClassifierListTitle(item, this.classifier.en).text
      } else {
        return ''
      }
    },
    getClassifierListTitle(listItem, list) {
      return list.filter((item) => item.value === listItem)[0]
    },
    getClassifierTitle(list) {
      return list.filter((item) => item.value === this.item)[0]
    },
  },
}
</script>

<style lang="scss" scoped></style>
